import axios from "axios";
import config from "../../../Helpers/config.json";
import {useEffect, useState} from "react";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import {history} from "../../../Helpers/history";

export const useAddRole = (actions, match) => {
    const {id, role_name} = match;
    const [role_id, setRoleId] = useState('');
    const [roles, setRoles] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [roleUpdate, setRoleUpdate] = useState([])

    useEffect(() => {
        axios.get(`${config.epharmUrl}/Permission/retrieve_all_roles`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const list = !dt.role_list ? [] : dt.role_list;
            const ls = list.map(item => ({
                check: false,
                title: item.module_name,
                content: item.params.map(item=>({...item, checkedRow:false}))
            }))
            setRoles(ls)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }, [actions])

    // useEffect(() => {
    //     const ls = data.map(item => ({
    //         check: false,
    //         title: item.module_name,
    //         content: item.params.map(item=>({...item, checkedRow:false}))
    //     }))
    //     setRoles(ls)
    // }, [data])
    
    useEffect(() =>{
        if (!id){
            return
        }
        axios.get(`${config.epharmUrl}/Permission/edit_role`, {params: {id}}).then(res => {
            const dt = res.data;
            const roles = dt ? dt :{};
            setRoleUpdate(roles)
        }).catch(error => {
            errorMessages(error, null, actions)
        })
        
    },[actions, id])

    const  parseRoles = (role_details) =>{
        let arr= [];
        for(let i in role_details.module){
            let content = []
            for(let m in role_details.role_detail){
                if(role_details.role_detail[m].module_name === role_details.module[i].name){
                    let myObj = {create: role_details.role_detail[m].create,
                        delete: role_details.role_detail[m].delete,
                        sub_module_id: role_details.role_detail[m].fk_module_id,
                        id: role_details.role_detail[m].id, sub_module_name: role_details.role_detail[m].name,
                        read: role_details.role_detail[m].read,update: role_details.role_detail[m].update}
                    content.push(myObj)
                }
            }
            let obj = {
                title:role_details.module[i].name,
                content:content
            }
            arr.push(obj)
        }
        return arr
    }


    useEffect(()=>{
        if (!id){
            return;
        }
        const role_permissions = parseRoles(roleUpdate)
        setRoleId(role_name)
        setRoles(role_permissions)
    },[id, roleUpdate, role_name])



    const handleChange = (event) => {
        const {value} = event.target;
        setRoleId(value)
    };

    const handleChangeCheckAll = (event, index) => {
        const {checked} = event.target;
        const arr = roles.map((item, idx) => {
            if (index === idx) {
                return {
                    ...item, check: checked,
                    content: item.content.map(it => {
                        return {...it, create: checked, read: checked, update: checked, delete: checked,checkedRow:checked}
                    })
                }
            }
            return item
        })
        setRoles(arr)
    }

    const handleCheckRow = (event, index,  ind) => {
        const {checked} = event.target;
        const arr = roles.map((item, idx) => {
            if (index === idx) {
                return {
                    ...item,
                    content: item.content.map((it, i) => {
                        if (i === ind) {
                            return {...it, create: checked, read: checked, update: checked, delete: checked,checkedRow:checked}
                        }
                        return it
                    })
                }
            }
            return item
        })
        setRoles(arr)
    };

    const handleChangeCheck = (event, index,  ind) => {
        const {checked, name} = event.target;
        const arr = roles.map((item, idx) => {
            if (index === idx) {
                return {
                    ...item,
                    content: item.content.map((it, i) => {
                        if (i === ind) {
                            return {...it, [name]: checked}
                        }
                        return it
                    })
                }
            }
            return item
        })
        setRoles(arr)
    };
    const submitRole = (event) => {
        event.preventDefault();
        const formData = new FormData();
        if (id){
            formData.append('rid',id);
        }
        formData.append('role_id', role_id);
        setSubmitted(true)
        const arr = roles.some(item=>item.content.some(row => +row.create || +row.read || +row.update || +row.delete))
        if (role_id && arr) {
            setIsSubmitted('pending')
            roles.forEach(it=>{
                it.content.forEach(item => {
                    formData.append('fk_module_id', item.sub_module_id);
                    formData.append('create', +(item.create));
                    formData.append('read', +(item.read));
                    formData.append('update', +(item.update));
                    formData.append('delete', +(item.delete));
                })
            })
            const url = id ? 'update' : 'create'
            axios.post(`${config.epharmUrl}/Permission/${url}`, formData).then(() => {
                setIsSubmitted('resolved')
                actions.snackbarActions.successSnackbar('Role added successfully!');
                history.push('/rolelist')
            }).catch(error => {
                setIsSubmitted('rejected')
                errorMessages(error, null, actions)
            })
            // roles.forEach(row => {
            //     row.content.forEach(role => {
            //         role.create = false;
            //         role.read = false;
            //         role.update = false;
            //         role.delete = false;
            //     })
            // });
        } else {
            window.scrollTo(0, 0);
        }


    };
    const handleCloseBar = () => {
        actions.snackbarActions.hideSnackBar()
    };

    return {
        role_id, roles, submitted, isSubmitted,handleCheckRow,
        handleChange, handleChangeCheckAll, handleChangeCheck, submitRole, handleCloseBar
    }
}